/* Simple jQuery Equal Heights @version 1.5.1. Copyright (c) 2013 Matt Banks. Dual licensed under the MIT and GPL licenses. */
!function(a){a.fn.equalHeights=function(){var b=0,c=a(this);return c.each(function(){var c=a(this).innerHeight();c>b&&(b=c)}),c.css("height",b)},a("[data-equal]").each(function(){var b=a(this),c=b.data("equal");b.find(c).equalHeights()})}(jQuery);

/* Run function after window resize */
var afterResize=(function(){var t={};return function(callback,ms,uniqueId){if(!uniqueId){uniqueId="Don't call this twice without a uniqueId";}if(t[uniqueId]){clearTimeout(t[uniqueId]);}t[uniqueId]=setTimeout(callback,ms);};})();

window.theme = window.theme || {};

theme.cacheSelectors = function () {
  theme.cache = {
    // General
    $w: $(window),
    $body: $('body'),
    // Mobile Nav
    $mobileNavTrigger: $('#MobileNavTrigger'),
    $mobileNav: $('#MobileNav'),
    $mobileSublistTrigger: $('.mobile-nav__sublist-trigger'),
    // Equal height elements
    $productGridImages: $('.grid-link__image--product'),
    $featuredGridImages: $('.grid-link__image--collection'),
    // Product page
    $productImage: $('#ProductPhotoImg'),
    $productImageGallery: $('.gallery__item'),
    // Cart Page
    cartNoteAdd: '.cart__note-add',
    cartNote: '.cart__note',
    cartGiftMessageAdd: '.cart__gift-message-add',
    cartGiftMessage: '.cart__gift-message',
    // Add to cart - Ajax
    $cartCount: $('.cart-count'),
    $addToCartBtn: $('form[action^="/cart/add"] :submit'),
    //Navigation
    $hasDropdownItem: $('.site-nav--has-dropdown')
  }
};
timber.cacheVariables=function(){timber.vars={isTouch:timber.cache.$html.hasClass("supports-touch")}};
theme.init = function () {
  theme.cacheSelectors();
  theme.mobileNav();
  timber.cacheVariables();
  theme.equalHeights();
  theme.cartPage();
  theme.toggleMenu();
  
  theme.enableAjax();
};

theme.mobileNav = function () {
  theme.cache.$mobileNavTrigger.on('click', function() {
    theme.cache.$mobileNav.slideToggle(220);
  });

  theme.cache.$mobileSublistTrigger.on('click', function(evt) {
    var $el = $(this);
    // Enable commented out if statement to allow direct clicking on trigger link
    // if (!$el.hasClass('is-active')) {
      evt.preventDefault();
      $el.toggleClass('is-active').next('.mobile-nav__sublist').slideToggle(200);
    // }
  });
};

theme.equalHeights = function () {
  theme.cache.$w.on('load', resizeElements());
  theme.cache.$w.on('resize',
    afterResize(function() {
      resizeElements();
    }, 250, 'equal-heights')
  );
  function resizeElements(){theme.cache.$productGridImages.css("height","auto").equalHeights(),theme.cache.$featuredGridImages.css("height","auto").equalHeights()}
};

theme.productImageGallery = function() {
  if (!theme.cache.$productImageGallery.length) {
    return;
  };

  theme.cache.$productImageGallery.magnificPopup({
    type: 'image',
    mainClass: 'mfp-fade',
    closeOnBgClick: true,
    closeBtnInside: false,
    closeOnContentClick: true,
    tClose: 'Close (Esc)',
    removalDelay: 500,
    callbacks: {
      open: function(){
        $('html').css('overflow-y','hidden');
      },
      close: function(){
        $('html').css('overflow-y','');
      }
    },
    gallery: {
      enabled: true,
      navigateByImgClick: false,
      arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"><span class="mfp-chevron mfp-chevron-%dir%"></span></button>',
      tPrev: 'Previous (Left arrow key)',
      tNext: 'Next (Right arrow key)'
    }
  });

  theme.cache.$productImage.bind('click', function() {
    var imageId = $(this).attr('data-image-id');
    theme.cache.$productImageGallery.filter('[data-image-id="' + imageId + '"]').trigger('click');
  });
};

theme.cartPage = function () {
  

  theme.cache.$body.on('click', theme.cache.cartNoteAdd, function () {
    $(this).addClass('is-hidden');
    $(theme.cache.cartNote).addClass('is-active');
    ajaxifyShopify.sizeDrawer();
  });

	theme.cache.$body.on('click', theme.cache.cartGiftMessageAdd, function () {
    //$(this).addClass('is-hidden');
		$('#gift-message').attr('checked', true).trigger('change');
    $(theme.cache.cartGiftMessage).addClass('is-active');
  });
};

theme.backButton=function(){var e=r(document.referrer);if(r(document.url)===e)return history.back(),!1;function r(e){var r=document.createElement("a");return r.href=e,r.hostname}};

theme.addToCartflip = function ($addToCartBtn) {
  // Get label of add to cart button
  var addToCartText = $addToCartBtn.attr('data-add-to-cart') || "Add to Bag";
  // Make a copy of the add to cart button should we flip it
  $addToCartBtn
    .clone(true)
    .prop('disabled', false)
    .removeClass('disabled')
    .addClass('btn--unflipped')
    .find('span')
    .text(addToCartText)
    .end()
    .hide()
    .insertAfter($addToCartBtn);
	setTimeout(function(){timber.RightDrawer.open();}, 500);
  $addToCartBtn
    .unbind('click')
    .removeClass('disabled')
    .find('span')
		
    //.text("View Bag")
		
    .end()
    .bind('click', function(e) {
      e.preventDefault();
      window.location.href = '/cart';
    })
    .prop('disabled', false)
    .addClass('btn--flipped')
		;

  $('.continue-shopping a').bind('click', theme.backButton);
  // Unflip button if another variant is selected
  $('.single-option-selector, .swatch, [name="quantity"]').bind('click', function() {
    $(this).closest('form').find('.btn--flipped, .continue-shopping, .note').remove();
    $(this).closest('form').find('.btn--unflipped').removeClass('.btn--unflipped').show();
  });
};

/*
* Set values for cart threshold message based on discount paremeters and current cart
*/
theme.cartThresholdMessage = function (cart) {
	var thresholdAmount1 = parseInt("0");
	var thresholdDiscount1 = "15%";
	var thresholdAmount2 = parseInt("50");
	var thresholdDiscount2 = "20%";
	var thresholdAmount3 = parseInt("200");
	var thresholdDiscount3 = "30%";
	var cartTotal = (cart.original_total_price / 100).toFixed(2);
	if(cartTotal >= thresholdAmount3) {
		$('#cart_threshold_message .current_discount').html(thresholdDiscount3);
		$('#cart_threshold_message .more').html("That's as high as it goes!");
	} else if (cartTotal >= thresholdAmount2) {
		$('#cart_threshold_message .current_discount').html(thresholdDiscount2);
		$('#cart_threshold_message .more .spend').html('$' + (thresholdAmount3 - cartTotal).toFixed(2));
		$('#cart_threshold_message .next_discount').html(thresholdDiscount3);
	} else if (cartTotal >= thresholdAmount1) {
		$('#cart_threshold_message .current_discount').html(thresholdDiscount1);
		$('#cart_threshold_message .more .spend').html('$' + (thresholdAmount2 - cartTotal).toFixed(2));
		$('#cart_threshold_message .next_discount').html(thresholdDiscount2);
	} else {
		$('#cart_threshold_message .message').html('');
		$('#cart_threshold_message .more .spend').html('$' + (thresholdAmount1 - cartTotal).toFixed(2));
		$('#cart_threshold_message .next_discount').html(thresholdDiscount1);
	}
	$('#cart_threshold_message').show();
}

/*
* Enable Ajax add to cart, while checking for add-ons
*/
theme.enableAjax = function () {
  theme.cache.$addToCartBtn.bind('click', function(e) {
    //alert('Hi');
    e.preventDefault();
    $('.note.errors').remove();
    var $addToCartBtn = $(this),
        $addToCartForm = $(this).closest('form'),
        $addToCartBtnText = $(this).find('span');
    if ($addToCartForm.length) {
      $addToCartBtn
        .attr('data-add-to-cart', $addToCartBtnText.text())
        //.prop('disabled', true)
        //.addClass('disabled')
        .addClass('btn--loading');
			setTimeout(function(){timber.RightDrawer.open();}, 1000);	
			Shopify.queue = [];
		
			//See if there are any HTML5 required fields that aren't filled
			//Returns false if required fields fail validation and AJAX add to cart should be stopped
			var requiredValidated = Shopify.checkForRequiredFields();
			
			//See if there are any add-on charges to add to the queue
			//Returns false if add-ons fail validation and cart add should be stopped
			var addonsValidated = Shopify.checkForAddOns();
			//var formData = JSON.parse($("#AddToCartForm").serializeArray());
      		var formData = JSON.parse(JSON.stringify(jQuery('#AddToCartForm').serializeArray()));
			//console.log(requiredValidated);
			//console.log(formData);
            if (addonsValidated !== false && requiredValidated !== false) {
                //Add the main product from the form to the queue
                Shopify.queue.push({
                    data: formData
                });
                if($(".initials_letter_wrapper").length  > 0){
                    Shopify.moveAlongInitial();
                }else{
                    Shopify.moveAlong();
                }
                
                
            } else {
                if($(".initials_letter_wrapper").length  > 0){
                }else{
                  $addToCartBtn
                        .prop('disabled', false)
                        .removeClass('disabled')
                        .removeClass('btn--loading');
                }
            }
    }
  });
};

/*
* Function to check for any empty required fields when an item is added to cart
*/
Shopify.checkForRequiredFields = function() {
	var validated = true;
	$('#AddToCartForm').find('input, select').each(function() {
		if($(this).prop('required') && !$(this).val()) {
			$(this).css('border-color', 'red');
			$('#error_message').html("*Oops, it looks like you're missing a required field");
			validated = false;
		}
	});
	return validated;
}

/*
* Function to check for any add-ons when an item is added to cart
*/
Shopify.checkForAddOns = function() {
	
	if ($.isFunction(Shopify.validateAddOns)) {
		//Validate AddOns data first to see if we should proceed
		var validated = Shopify.validateAddOns();
	} else {
		//No validateAddOns function exists on this page, return true to continue
		return true;
	}
	
	if(validated !== false) {
		
		
			var quantity = 1;
		
		
		var productTitle = $('h1[itemprop="name"]').html().replace(' ','+');
		
		
			if( $('#personalization').is(":checked") ) {
				var customization = $('#personalization_initials').val().replace(' ','+');
				Shopify.queue.push({
					variant_id: 16523246915,
					quantity: quantity,
					properties: {
						"Add-On For": productTitle + ' - ' + customization
					}
				});
			}
		
		
		
			if( $('input#leather_conditioner').is(":checked") ) {
				Shopify.queue.push({
					variant_id: 31911710926,
					quantity: 1,
					properties: {}
				});
			}
		
		
		
			if( $('input#leather_tassel').is(":checked") ) {
				$tassel_color = $('select#tassel_color').val();
				if( $tassel_color == 'cognac' ) {
					Shopify.queue.push({
						variant_id: 34041541134,
						quantity: quantity,
						properties: {
							"Add-On For": productTitle
						}
					});
				} else if ( $tassel_color == 'chocolate' ) {
					Shopify.queue.push({
						variant_id: 34041541198,
						quantity: quantity,
						properties: {
							"Add-On For": productTitle
						}
					});
				} else if ( $tassel_color == 'black' ) {
					Shopify.queue.push({
						variant_id: 34041541262,
						quantity: quantity,
						properties: {
							"Add-On For": productTitle
						}
					});
				} else if ( $tassel_color == 'pewter' ) {
					Shopify.queue.push({
						variant_id: 34041541326,
						quantity: quantity,
						properties: {
							"Add-On For": productTitle
						}
					});
				}	else if ( $tassel_color == 'denim-blue' ) {
					Shopify.queue.push({
						variant_id: 12493002506320,
						quantity: quantity,
						properties: {
							"Add-On For": productTitle
						}
					});
				}	else if ( $tassel_color == 'silver-metallic' ) {
					Shopify.queue.push({
						variant_id: 12792291786832,
						quantity: quantity,
						properties: {
							"Add-On For": productTitle
						}
					});
				}	else if ( $tassel_color == 'pale-dogwood' ) {
					Shopify.queue.push({
						variant_id: 12792291721296,
						quantity: quantity,
						properties: {
							"Add-On For": productTitle
						}
					});
				}	else if ( $tassel_color == 'pink-sand' ) {
					Shopify.queue.push({
						variant_id: 12792323735632,
						quantity: quantity,
						properties: {
							"Add-On For": productTitle
						}
					});
				}	else if ( $tassel_color == 'burgundy' ) {
					Shopify.queue.push({
						variant_id: 12792291852368,
						quantity: quantity,
						properties: {
							"Add-On For": productTitle
						}
					});					
				} else {
					Shopify.queue.push({
						variant_id: 34041541134,
						quantity: quantity,
						properties: {
							"Add-On For": productTitle
						}
					});
				}
			}
		
		
		
			if( $('input#polishing_cloth').is(":checked") ) {
				Shopify.queue.push({
					variant_id: 42109975310,
					quantity: 1,
					properties: {}
				});
			}
		
		
		
			if( $('input#suede_protector').is(":checked") ) {
				Shopify.queue.push({
					variant_id: 2085795004440,
					quantity: 1,
					properties: {}
				});
			}
		
		
			if( $('input#suede_cleaner').is(":checked") ) {
				Shopify.queue.push({
					variant_id: 2075271790616,
					quantity: 1,
					properties: {}
				});
			}
		
		
			if( $('input#suede_brush').is(":checked") ) {
				Shopify.queue.push({
					variant_id: 3338721460248,
					quantity: 1,
					properties: {}
				});
			}
		
	
		if( $('#tiny_tag_2').is(":checked") ) {
			var customization = $('#tiny_tag_2_select').val().replace(' ','+');
			Shopify.queue.push({
				variant_id: 28298782736464,
				quantity: quantity,
				properties: {
					"Add-On For": productTitle + ' - ' + customization
				}
			});
		}
		if( $('#tiny_tag_3').is(":checked") ) {
			var customization = $('#tiny_tag_3_select').val().replace(' ','+');
			Shopify.queue.push({
				variant_id: 28298782736464,
				quantity: quantity,
				properties: {
					"Add-On For": productTitle + ' - ' + customization
				}
			});
		}
      
      
      
        // adding below for 4th tiny tag add-on
      	if( $('#tiny_tag_4').is(":checked") ) {
			var customization = $('#tiny_tag_4_select').val().replace(' ','+');
			Shopify.queue.push({
				variant_id: 28298782736464,
				quantity: quantity,
				properties: {
					"Add-On For": productTitle + ' - ' + customization
				}
			});
		}
      	if( $('#tiny_tag_5').is(":checked") ) {
			var customization = $('#tiny_tag_5_select').val().replace(' ','+');
			Shopify.queue.push({
				variant_id: 28298782736464,
				quantity: quantity,
				properties: {
					"Add-On For": productTitle + ' - ' + customization
				}
			});
		}      
      
      
      
      
		return true;
		
	} else {
		//Return false to stop main product being added
		return false;
	}
	
}


/* ISQ  */
Shopify.moveAlongInitial = function () {
    // If we still have requests in the queue, let's process the next one.
  //console.log('movealong...');
    if (Shopify.queue.length) {
       // console.log('movealong initial queue has length');
        var request = Shopify.queue.shift();
        var data;
        
        if (request.data) {
            data = request.data;
        } else {
            var properties = '';
            jQuery.each(request.properties, function (i, val) {
                if (val) {
                    properties += '&properties%5B' + i + '%5D=' + val;
                }
            });
            data = 'quantity=' + request.quantity + '&id=' + request.variant_id + properties;
        }

    console.log("DATA START");
      console.log(request.data);
      
        // var variant =  $('.swatch-element.selected').attr("data-variant-id");
      	var variant = $('#productSelect').val();
        /* var prt = $("#monogram_letter_1").val();
        if(prt!='' || prt!=undefined){
            var properties = {
              'First Letter': prt
            }
        }else{
            var properties = "";
        }
        */
      	var properties = {};
      	$(".otherLetters").each(function(){
          var clsss= $(this).attr("data-cls");
          var othltr = $('option:selected', this).val();
          var diena = clsss+" Letter";  
          properties[diena] = othltr;
        });
        var params1 = {
          quantity: 1,
          id: variant, 
          properties: properties
        };
        var params = {
            type: 'POST',
            url: '/cart/add.js',
            data: params1,
            dataType: 'json',
            success: function (line_item) {
                Shopify.lettersAdd(variant);
              	//console.log('movealong initial ajax success');
            },
            error: function (xhr, status, error) {
                Shopify.moveAlongInitial();
            }
        };
        $.ajax(params);
    }
    // If the queue is empty, we will Ajax update or redirect to the cart page
    else {
    }  
};
Shopify.lettersAdd = function (parentVariantId) {
    /* Initials Necklace Add-ons */
    var myar =[];
    $(".otherLetters").each(function(){
        var clsss= $(this).attr("data-cls");
        var othltr = $('option:selected', this).val();
        var selectedVariant = $('option:selected', this).data('variant');      
       // var arr = {cls + ' : ' + othltr};
        var diena = clsss+" Letter";
        var obj = {};
        obj[diena] = othltr;
      	obj["_parentVariant"]= parentVariantId
        if(othltr!=''){
            var params = {
              quantity: 1,
              // id: 31536477012057,
              id: selectedVariant,
              properties:obj
            };
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                async:false,
                dataType: 'json',
                data: params,
                success: function(){
                  //alert("Other letter");
                  //console.log('letters added successfully');
                },
                error: function(){
                }
            });
        }
    });
    if (typeof (upsell_main) === "function") {
        upsell_main();
    }
    if (typeof (upsell_offer) === "function") {
        upsell_offer();
        jQuery('#giveacceptbtn,#giveclosebtn,.close_image,#facebox_overlay').on('click', function () {
            var $addToCartBtn = $('button#AddToCart');
            $.getJSON('/cart.js', function (cart) {
                theme.cache.$cartCount.text(cart.item_count);
                $('.hidden-count').removeClass('hidden-count');
                updateCartDropdown(cart);
            });
            //$addToCartBtn.removeClass('btn--loading');
            // theme.addToCartflip($addToCartBtn);
        });
    } else {
        var $addToCartBtn = $('button#AddToCart');
        $.getJSON('/cart.js', function (cart) {
            theme.cache.$cartCount.text(cart.item_count);
            $('.hidden-count').removeClass('hidden-count');
            updateCartDropdown(cart);
          	//console.log('refreshing cart now');
        });
        $addToCartBtn.removeClass('btn--loading');
        //theme.addToCartflip($addToCartBtn);
    }
};
/* ISQ  */

/*
* moveAlong function to add products to the cart using Ajax sequentially
*/
Shopify.moveAlong = function() {
  // If we still have requests in the queue, let's process the next one.
  if (Shopify.queue.length) {
    var request = Shopify.queue.shift();
		var data;
    //console.log(request.properties);
		if(request.data) {
			data = request.data;
          
		} else {
			var properties = '';
			jQuery.each(request.properties, function(i, val) {
				if(val) {
					properties += '&properties%5B' + i + '%5D=' + val;
				}
			});
			data = 'quantity='+request.quantity+'&id='+request.variant_id+properties;
		}
		
  //console.log(data);
		var params = {
			type: 'POST',
			url: '/cart/add.js',
      data: data,
			dataType: 'json',
			success: function(line_item) {
				Shopify.moveAlong();
			},
			error: function(xhr, status, error) {
				Shopify.moveAlong();
			}
		};
		$.ajax(params);
		
  }
  // If the queue is empty, we will Ajax update or redirect to the cart page
  else {
	
		/* Bold Apps Upsell Added Function */
		if (typeof(upsell_main) === "function") {
		  upsell_main();
		}
		if (typeof(upsell_offer) === "function") { 
		  upsell_offer(); 
		  jQuery('#giveacceptbtn,#giveclosebtn,.close_image,#facebox_overlay').on('click', function(){ 
		    
				
					var $addToCartBtn = $('button#AddToCart');
			    $.getJSON('/cart.js', function(cart) {
			      theme.cache.$cartCount.text(cart.item_count);
			      $('.hidden-count').removeClass('hidden-count');
						updateCartDropdown(cart);
						
			    });
			    $addToCartBtn.removeClass('btn--loading');
			   // theme.addToCartflip($addToCartBtn);
				
		
		  });
		} else { 
		 
			
				var $addToCartBtn = $('button#AddToCart');
		    $.getJSON('/cart.js', function(cart) {
		      theme.cache.$cartCount.text(cart.item_count);
		      $('.hidden-count').removeClass('hidden-count');
					updateCartDropdown(cart);
					
		    });
		    $addToCartBtn.removeClass('btn--loading');
		    //theme.addToCartflip($addToCartBtn);
			
		
		}

  }
};

/*
* moveAlong function to remove products to the cart using Ajax sequentially
*/
Shopify.moveAlongRemove = function() {
	// If we still have requests in the queue, let's process the next one.
	if (Shopify.removeQueue.length) {
		var request = Shopify.removeQueue.shift();
		var lineNum = request.lineNum;
		var data = {
		  quantity: 0,
		  line: lineNum
		}
		var params = {
			type: 'POST',
			url: '/cart/change.js',
      data: data,
			dataType: 'json',
			success: function(line_item) {
				Shopify.moveAlongRemove();
			},
			error: function(xhr, status, error) {
				Shopify.moveAlongRemove();
			}
		};
		$.ajax(params);
	}
  // If the queue is empty, we will redirect to the cart page.
  else {
     //document.location.href = '/cart';
    $('.shopping_bag .cart-count').text($('.cart_dropdown .cart__row:visible').length);
  }
    $.getJSON('/cart.js', function (cart) {
    theme.cache.$cartCount.text(cart.item_count);
    $('.hidden-count').removeClass('hidden-count');
    updateCartDropdown(cart);
    console.log('refreshing cart now');
     if(cart.total_price<=0)
     {
       $('.addmorediscount').hide();                  
       $('.cart_dropdown .empty_cart').show();
       $('.cart_dropdown .cart_actions').hide();
       $('.cart_dropdown .cartfooter').hide();
        $('.text-center.chkbtn.tn-checkout-btn-container').hide();
     }
  });
}

//Product Removing
function removeItem(lineNum) {
	jQuery.post('/cart/change.js', { quantity: 0, line: lineNum });
}
function removeChildren(event, lineNum) {
	Shopify.removeQueue = [];
	
	event.preventDefault();
	var children = $('.cart__row.row_' + lineNum).nextUntil('.parent').toArray();
	children.reverse();
	$(children).each(function() {
		var childLineNum = parseInt( $(this).data('line') );
		Shopify.removeQueue.push({lineNum: childLineNum});
	});
	Shopify.removeQueue.push({lineNum: lineNum});
	Shopify.moveAlongRemove();
}

theme.toggleMenu = function () {
  var $doc = $(document);
  var showDropdownClass = 'show-dropdown';

  // Open sub navs on small screens
  theme.cache.$hasDropdownItem.on('click', function(evt) {
    var $el = $(this);

    if (!$el.hasClass(showDropdownClass) && timber.vars.isTouch) {
      evt.preventDefault();
      $el.addClass(showDropdownClass);
      $doc.on('click', handleClickOutsideDropdown);
    }

    function handleClickOutsideDropdown (evt) {
      var $target = $(evt.target);

      if (!$target.is($el) && !$.contains($el[0], $target[0])) {
        $el.removeClass(showDropdownClass);
        $doc.off('click', handleClickOutsideDropdown)
      }
    }
  })
};

// Initialize theme's JS on docready
$(theme.init)

//Sticky Menu


// Storyside changing this for new desktop menu
var sticky = new Waypoint.Sticky({
  element: $('.new-sticky-nav')[0]
});

// Storyside commenting out to fix error that sidebar was not showing bc this element did not exist anymore
// var stickyMobile = new Waypoint.Sticky({
//   element: $('.site-nav-wrapper--mobile')[0]
// });

//Zoom

$.fn.zoom = function () {
  $('#zoomed img').removeData('elevateZoom');
  $('.zoomWrapper img.zoomed').unwrap();
  $('.zoomContainer').remove();
  $(this).elevateZoom({
    zoomActivation: "click",
	zoomEnabled: true,
    gallery:'ProductThumbs',
		borderColour: '#fff',
		tint: false,
		responsive: true,
		scrollZoom : false
  });
};
//Portrait/Landscape Classes
$(window).load(function() {
    $('#zoomed img').removeData('elevateZoom');
    $('.zoomWrapper img.zoomed').unwrap();
    $('.zoomContainer').remove();
  	//Review
  
	$('.reveal .hidden img').each(function(){
	    $(this).addClass(this.width > this.height ? 'landscape' : 'portrait');
	});
	//For product pages, add landscape class only if thumbs are below product image
	$('.large--one-half > .product-single__thumbnails li img').each(function(){
		if(this.width > this.height) {
			$(this).addClass('landscape');
			$(this).parent().parent('li').removeClass('large--one-sixth').addClass('large--two-sixths');
		}
	});
});

//Custom Lightbox Popups
$(document).ready(function() {
  $('.lightbox').magnificPopup({
    type: 'image',
    mainClass: 'mfp-fade',
		removalDelay: 1000
	});
	
	$('.lightbox-inline').magnificPopup({
    type: 'inline',
    mainClass: 'mfp-fade'
	});
	
	$('.lightbox-zoom').magnificPopup({
    type: 'image',
    mainClass: 'mfp-fade',
		removalDelay: 1000,
		image: {
			verticalFit: false
		}
	});
});

// -------------------------------------------------------------------------------------
// Helper Functions
// -------------------------------------------------------------------------------------

function ringBarSubmit() {
	Shopify.queue = [];
	if( $('#ring_bar_results') ) {
		$('#ring_bar_results .ring_result[data-variant-id!=""]').each(function() {
			if(!$(this).closest('div.ui-accordion').hasClass('ui-state-disabled')) {
				
				var id = $(this).attr('data-variant-id');
				var color = $(this).attr('data-color-id');
				var stone = $(this).attr('data-stone-id');
				var add_on_variant_id = $(this).attr('data-add-on-id');
				var stamp = $(this).attr('data-stamp-id');
				var size = $(this).attr('data-size-id');
				var discount = $(this).attr('data-discount-id');
				var backordered = $(this).attr('data-backordered');

				Shopify.queue.push({
					variant_id: id,
					quantity: 1,
					properties: {
						Metal: color,
						Stone: stone,
						Stamp: stamp,
						Size: size,
						Backordered: backordered
					}
				});

				if(add_on_variant_id) {
					Shopify.queue.push({
						variant_id: add_on_variant_id,
						quantity: 1,
						properties: {
							"Add-On For": stone + " Stone"
						}
					});
				}
				
			}
			
		});
		
		Shopify.queue.reverse();
	}
	Shopify.moveAlong();
}

/* Manage Cookies */
function createCookie(name, value, days) {
	var expires;
	if (days) {
	  var date = new Date();
	  date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
	  expires = "; expires=" + date.toGMTString();
	} else {
		expires = "";
	}
	document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
}

function readCookie(name) {
	var nameEQ = encodeURIComponent(name) + "=";
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
	  var c = ca[i];
	  while (c.charAt(0) === ' ') c = c.substring(1, c.length);
	  if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
	}
	return null;
}

function eraseCookie(name) {
	createCookie(name, "", -1);
}

/* Control load order */
$('body.template-index .split_images').css('visibility','hidden');
window.onload = function() {
	$('body.template-index .split_images').css('visibility','visible').hide().fadeIn();
};

// -------------------------------------------------------------------------------------
// AJAX API Helpers
// -------------------------------------------------------------------------------------

Shopify.onError = function(XMLHttpRequest, textStatus) {
  // Shopify returns a description of the error in XMLHttpRequest.responseText.
  // It is JSON.
  // Example: {"description":"The product 'Amelia - Small' is already sold out.","status":500,"message":"Cart Error"}
  var data = eval('(' + XMLHttpRequest.responseText + ')');
	//console.log(data);
  //alert(data.message + '(' + data.status  + '): ' + data.description);
}; 

Shopify.onItemAdded = function(line_item) {
	//console.log(line_item);
  //alert(line_item.title + ' was added to your shopping cart.');
};

// -------------------------------------------------------------------------------------
// POST to cart/add.js returns the JSON of the line item associated with the added item.
// -------------------------------------------------------------------------------------
Shopify.addItem = function(variant_id, quantity, callback, error_callback) {
  console.log(variant_id);
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function(line_item) { 
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
      else {
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
			if ((typeof error_callback) === 'function') {
        error_callback(XMLHttpRequest, textStatus, variant_id);
      }
      else {
        Shopify.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

/* Smooth Scroll On Anchors */
$(function() {
  $('a[href*="#"]:not([href="#"])').click(function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top - 80
        }, 1000);
        return false;
      }
    }
  });
});

$(document).ready(function() {
	
	$( ".ui-accordion" ).accordion({
		collapsible: true
	});
	
	$( ".ui-accordion-collapsed" ).accordion({
		active: false,
		collapsible: true
	});
	
	/* Allow only alpha text input */
	$('form input[type="text"].alpha-only').keypress(function (e) {
		var regex = new RegExp("^[a-zA-Z]+$");
		var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
		if (regex.test(str)) {
			return true;
		}

		e.preventDefault();
		return false;
	});
	
	$('form input[type="text"].alpha-only').bind("paste",function(e) {
		var regex = new RegExp("^[a-zA-Z]+$");
		var str = e.originalEvent.clipboardData.getData('Text');
		if (regex.test(str)) {
			return true;
		}

		e.preventDefault();
		return false;
  });
	
	/* Allow only alphanumeric product properties */
	$('form input[type="text"].alphanumeric-only').keypress(function (e) {
		var regex = new RegExp("^[a-zA-Z0-9]+$");
		var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
		if (regex.test(str)) {
			return true;
		}

		e.preventDefault();
		return false;
	});
	
	$('form input[type="text"].alphanumeric-only').bind("paste",function(e) {
		var regex = new RegExp("^[a-zA-Z0-9]+$");
		var str = e.originalEvent.clipboardData.getData('Text');
		if (regex.test(str)) {
			return true;
		}

		e.preventDefault();
		return false;
  });
  
  
	/* Allow only alphanumeric product properties AND spaces */
	$('form input[type="text"].alphanumeric-and-space-only').keypress(function (e) {
		var regex = new RegExp("^[a-zA-Z0-9 ]+$");
		var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
		if (regex.test(str)) {
			return true;
		}

		e.preventDefault();
		return false;
	});
	
	$('form input[type="text"].alphanumeric-and-space-only').bind("paste",function(e) {
		var regex = new RegExp("^[a-zA-Z0-9 ]+$");
		var str = e.originalEvent.clipboardData.getData('Text');
		if (regex.test(str)) {
			return true;
		}

		e.preventDefault();
		return false;
  });  
  

	/* Allow only alphanumeric product properties */
	$('form input[type="text"].alphanumericspecial-only').keypress(function (e) {
		var regex = new RegExp("^[a-zA-Z0-9:;\\-\\/().,'!&?]+$");
		var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
		if (regex.test(str)) {
			return true;
		}

		e.preventDefault();
		return false;
	});
	
	$('form input[type="text"].alphanumericspecial-only').bind("paste",function(e) {
		var regex = new RegExp("^[a-zA-Z0-9:;\\-\\/().,'!&?]+$");
		var str = e.originalEvent.clipboardData.getData('Text');
		if (regex.test(str)) {
			return true;
		}

		e.preventDefault();
		return false;
  });

	/* Convert all letters to lowercase */
	$('form input[type="text"].lowercase-only').keyup(function (e) {
		var str = $(this).val();
		$(this).val(str.toLowerCase());
	});
	
	$('form input[type="text"].lowercase-only').bind("paste",function(e) {
		var str = $(this).val();
		$(this).val(str.toLowerCase());
  });
	
});

/* Cart Dropdown */

$(document).ready(function() {
	initRemoveItemsFromCartDropdown();
  if($(window).width() <= 768){
      toggleFooter();
  }

});


//Toggle Footer Menu

function toggleFooter(){
  var allPanels = $('.foot_section > ul').hide();
  // Toggle Footer Menu
  $('.foot_section  h4').click(function() {
    allPanels.slideUp();
    $('.foot_section  h4').not($(this)).removeClass('active');;
    $('.footer-linklist-one').removeClass("active");
    if($(this).hasClass("active")){

      $(this).removeClass("active");
      $(this).next().removeClass("active");
      $(this).next().slideUp(350);  
    }else{

      $(this).addClass("active");
      $(this).next().addClass("active");
      $(this).next().slideDown(350);  

    }

    return false;
  });
}


function updateCartDropdown(cart) {
  
	rebuildCartDropdown(cart);
	$('.shopping_bag .cart_dropdown').show();
}

function rebuildCartDropdown(cart) {
  
	var tryNowCart = false;
	var backOrder = false;
	var tryNowAvailable = false;
	var tryNowLimit = 8;
	var tryNowItemsCount = 0;
  	var cart_lines = '';
	for (var i = 1; i <= cart.items.length; i++) {

      var line_item = cart.items[i-1];
      /* ISQ Fix cart drawer Discounted Price issue */
        var loadURL = line_item.url;
        var variant_id = line_item.variant_id;
        getprice(loadURL,variant_id);
	  /* END */
      
      /* 16459043 */
      var is_master = ' childitem';
      if(line_item.product_type !='')
      {
        is_master=" master";
      }
      /**/
	  var line_html = '<div data-parent-variant-id = '+ line_item.properties._parentVariant +' class="cart__row row_item row_' + i + ' text-thin parent id-' + line_item.product_id + is_master+ ' " data-variant-id="' + line_item.variant_id + '" data-line="' + i + '">' +
			'<div class="grid--full">' +
				'<div class="image_wrapper grid__item one-fifth">' +
					'<a href="' + line_item.url + '" class="cart__image">' +
						'<img src="' + line_item.image + '" alt="' + line_item.title + '">' +
					'</a>' +
				'</div>' +
				'<div class="info_wrapper grid__item four-fifths text-left" style="padding-left:10px;">' +
					'<div class="product_title bold"><a href="' + line_item.url + '">' + line_item.product_title + '</a></div>' +
					'<div class="variant_title">' + line_item.variant_title + '</div>' +
					'<div class="price">Price: <s  id="compareme'+line_item.variant_id+'"><span class="money">'+Shopify.formatMoney(line_item.original_price)+'</span></s> <span class="money">' + Shopify.formatMoney(line_item.price)+ '</span></div>';
        line_html = line_html +'<div class="productPropertiesWraper" class="" data-id="'+line_item.variant_id+'" > ';
					
				/* ISQ Fix cart drawer Discounted Price issue above <S> Tag added */
					for(key in line_item.properties) {
					  if(key != "tn_enabled" && key != "tn_leather_bag"){
                      	var idHandle = (key).toLowerCase();
                      	idHandle = idHandle.replace(" ", "-");
						if(key.charAt(0) != "_" && line_item.properties.hasOwnProperty(key)) {
							var value = line_item.properties[key];
                          
                        
						
						if (value != "" && key != "Expected Ship"){
							line_html= line_html+'<div id="'+idHandle+'-'+line_item.variant_id+'" class="property lip personalization"><span class="name">'+key+'</span>: <span class="value">'+ value +'</span></div>';
						}
						if (value != "" && key == "Expected Ship"){
							line_html= line_html+'<div id="'+idHandle+'-'+line_item.variant_id+'" class="property lip expected-ship"><span class="name">'+key+'</span>: <span class="value">'+ value +'</span></div>';
						}
							
						}
						}else if(key == "tn_leather_bag"){
							// line_html= line_html+'<div id="leather-bag-'+line_item.variant_id+'" class="property lip leather-bag"><span class="name">Leather Bag</span></div>';
					  }else if(line_item.properties[key] == "true"){
						tryNowCart = true;
						tryNowItemsCount = tryNowItemsCount + line_item.quantity;
					  }

					  if(key == "Expected Ship" && line_item.properties[key] != ""){
						  backOrder = true;
					  }
					}

					if(line_item.properties.tn_enabled != undefined){
						tryNowAvailable = true;
					}

      

					/*line_html= line_html+'<div class="summary mini-margin-top">' +
						'<div class="quantity float-left">Quantity: <span class="qty">' + line_item.quantity + '</span></div>' +
						'<div class="line_price float-right text-normal"><span class="money">$' + (line_item.line_price/100).toFixed( 2 ) + '</span></div>' +
					'</div>' +
					'<div class="cart__remove" data-line="' + i + '"><span>x</span></div>' +
				'</div>' +
			'</div>' +
		'</div>';*/
      
          line_html = line_html + '</div><div class="tierdicount_price hidden">'+
                            '<div class="summary mini-margin-top">'+
                             '<div class="quantity float-left">Quantity: <span class="qty">'+line_item.quantity+'</span></div>'+
                              '<div class="line_price float-right text-normal"><s><span class="money">$'+((line_item.original_price*line_item.quantity) / 100).toFixed(2)+'</span></s></div>'+
                            '</div>'+
                            '<div class="summary mini-margin-top nospace">'+
                              '<div class="quantity float-left">Extra <span class="discountperc"></span>% discount</div>'+
                              '<div class="line_price float-right text-normal"><span class="money">$' + (line_item.line_price / 100).toFixed(2) + '</span></div>'+
                            '</div>'+
                          '</div>'+
                          '<div class="nontierdicount_price">'+
                            
                            '<div class="summary mini-margin-top">'+
                              '<div class="quantity float-left">Quantity: <span class="qty">' + line_item.quantity + '</span></div>'+
                              '<div class="line_price float-right text-normal"><span class="money">$' + (line_item.line_price / 100).toFixed(2) + '</span></div>'+
                            '</div>'+
                          '</div>' +       
                '<div class="cart__remove" data-line="' + i + '"><span>x</span></div>' +
                '</div>' +
                '</div>' +
                '</div>';
		
		cart_lines += line_html.replace('null', '');
     
	}
	cart_lines += "<!-- ISQ:15953794 --><div class='addmorediscount' data-cartamount='"+(cart.total_price / 100).toFixed(2)+"'></div><!-- END --><p class='empty_cart text-center no-margin hidden'>Your bag is currently empty.<br><a href='/collections/best-sellers'>Shop best sellers.</a></p>";
	$('.cart_dropdown .cart_items').html(cart_lines);
  	$('.cart_dropdown .cart_items').html(cart_lines);
  	if($('.tn-side-cart-widget').length == 0){
  		$('<div class="tn-side-cart-widget">You can add <span class="tn-items"></span> more items to your Try Before You Buy order.</div>').insertBefore( ".cart_actions.border-top.padding" );
    }
    if(tryNowCart){
		$('.cart_dropdown .subtotal .money').text('$0');
	}else{
		$('.cart_dropdown .subtotal .money').text('$'+(cart.total_price/100).toFixed( 2 ));
	}
	if( cart.items.length > 0 ) $('.cart_dropdown .cart_actions').show();
  	$('.cart_dropdown .cart_actions').show();
  $('.cart_dropdown .cartfooter').show()
    $('.text-center.chkbtn').show();
  
  
	initRemoveItemsFromCartDropdown();
  /* 16459043 */
    var elem = $('.cart_dropdown .cart_items').find('div.childitem').sort(sortMe);
    $('.cart_dropdown .cart_items').append(elem);

    var elem = $('.cart_dropdown .cart_items').find('div.master').sort(sortMe);
    $('.cart_dropdown .cart_items').append(elem);
    function sortMe(a, b) 
    {
      return a.dataset.line < b.dataset.line;
    }  
  
    $('.master .productPropertiesWraper').each(function() {
      var dataID = this.getAttribute('data-id');
      var letterLines = ['first-letter-','second-letter-', 'third-letter-', 'fourth-letter-', 'fifth-letter-', 'sixth-letter-'];
      for (i=0; i<6; i++){
        var currentProp = letterLines[i]+dataID;
        var currentPropid = '#'+letterLines[i]+dataID;
        // var toMove = document.getElementById(currentProp);
        var toMove = $(this).find("#" + currentProp);
        // $(currentPropid).remove();
        $(this).find(currentPropid).remove();
        $( this ).append(toMove);
      }
      
    });

	
	if(!backOrder && tryNowAvailable){
		if(tryNowCart){
			$('.tn-cart-side-disclaimer-toggle').addClass('tn-hidden')
			$('.tn-cart-side-disclaimer-no-toggle').removeClass('tn-hidden')
		}else{
			$('.tn-cart-side-disclaimer-toggle').removeClass('tn-hidden')
			$('.tn-cart-side-disclaimer-no-toggle').addClass('tn-hidden')
		}
	}else{
		$('.tn-cart-side-disclaimer-toggle').addClass('tn-hidden')
		$('.tn-cart-side-disclaimer-no-toggle').addClass('tn-hidden')
	}

	let tryNowRemain = 8;
	let leatherBagLimit = 3;
	let itemCount = 0;
	let tryCount = 0;
	let leatherCount = 0;
	fetch('/cart.json')
	.then(response => response.json())
	.then(cart => {
		if($('.tn-cart-side-disclaimer-toggle').css('display') != 'none'){
			cart.items.forEach((item, index)=>{
				itemCount = itemCount + item.quantity;
				for(key in item.properties) {
					if(key == "tn_leather_bag") {
						leatherCount = leatherCount + item.quantity;
					}
					if(key == "tn_enabled") {
						tryCount = tryCount + item.quantity;
					}
				}
			});
			if (leatherCount == itemCount) {
				if($('.tn-toggle').is(':checked')){
					tryNowRemain = leatherBagLimit - leatherCount;
					$('.cart_dropdown .subtotal .money').text('$0');
				}else{
					tryNowRemain = 0;
					$('.cart_dropdown .subtotal .money').text('$'+(cart.total_price/100).toFixed( 2 ));
				}
			} else {
				if($('.tn-toggle').is(':checked')){
					tryNowRemain = tryNowRemain - itemCount;
					$('.cart_dropdown .subtotal .money').text('$0');
				}else{
					tryNowRemain = 0;
					$('.cart_dropdown .subtotal .money').text('$'+(cart.total_price/100).toFixed( 2 ));
				}
			}

			if(tryNowRemain > 0) {
				$('.tn-items').text(tryNowRemain)
				$('.tn-side-cart-widget').removeClass('tn-hidden')
			}else{
				$('.tn-side-cart-widget').addClass('tn-hidden')
			}
		}else{
			cart.items.forEach((item, index)=>{
				itemCount = itemCount + item.quantity;
				for(key in item.properties) {
					if(key == "tn_leather_bag") {
						leatherCount = leatherCount + item.quantity;
					}
					if(key == "tn_enabled") {
						tryCount = tryCount + item.quantity;
					}
				}
			});
			if (leatherCount == itemCount) {
				tryNowRemain = leatherBagLimit - leatherCount;
			} else {
				tryNowRemain = tryNowRemain - tryNowItemsCount;
			}

			if(
				(tryNowRemain > 0 && itemCount > 0 && tryCount > 0) || 
				(tryNowRemain > 0 && itemCount > 0 && $('.tn-toggle').is(':checked'))
			) {
				$('.tn-items').text(tryNowRemain)
				$('.tn-side-cart-widget').removeClass('tn-hidden')
			}else{
				$('.tn-side-cart-widget').addClass('tn-hidden')
			}
		}
	});
}

function renumberCartDropdownLines() {
	var index = 1;
	$('.cart_dropdown .cart_items .cart__row').each(function() {
		$(this).attr('data-line', index);
		$(this).find('.cart__remove').attr('data-line', index);
		index++;
	});
}

function initRemoveItemsFromCartDropdown() {
	$('header.site-header .cart_dropdown .cart__remove').on('click', function(event) {
      // console.clear();   
      	Shopify.removeQueue = [];
		var line_num = $(this).data('line');
		var line_price = parseFloat( $(this).closest('.cart__row').find('.line_price .money').text().replace('$', '') );
		var line_quantity = parseInt( $(this).closest('.cart__row').find('.nontierdicount_price .quantity .qty').text() );
		var quantity = parseInt( $('.shopping_container .shopping_bag .cart-count').text() );
		var subtotal = parseFloat( $('.cart_dropdown .cart_actions .subtotal .money').text().replace('$', '') );
		var new_subtotal = subtotal - line_price;
		var new_quantity = quantity - line_quantity;      
		var variantId =  $(this).closest('.cart__row').data('variant-id')
        var pvariantId =  $(this).closest('.cart__row').data('parent-variant-id');
        Shopify.removeQueue.push({lineNum: line_num});      
		$(this).closest('.cart__row').fadeOut(300, function() { 
			//$(this).remove();
           console.log("new_subtotal "+new_subtotal);
			$('.cart_dropdown .cart_actions .subtotal .money').text('$' + new_subtotal);
			$('.shopping_bag .cart-count').text(new_quantity);
			if( new_subtotal <= 0) {
               /** <!-- ISQ:15953794 --> **/
              $('.addmorediscount').hide();
              /* END */
				$('.cart_dropdown .empty_cart').show();
				$('.cart_dropdown .cart_actions').hide();
              $('.cart_dropdown .cartfooter').hide();
              //$('.text-center.chkbtn').eventhide();              
              event.stopPropagation();
			}
			renumberCartDropdownLines();
		});
      
      console.log("Cart Item here");
      //console.log(pvariantId +" ==> "+ variantId);
       if(pvariantId !== 'undefined' && pvariantId != ""){
         console.log("Click on child")    
         var items = $("div[data-parent-variant-id='" + pvariantId + "']"); 
          for (var i = 0; i <= items.length; i++) {
            var item = items[i]
            var id = $(item).data('line');            
            if(id != undefined){
              	Shopify.removeQueue.push({lineNum: id});
               $(item).fadeOut(300, function() { 
                 // $(item).remove();
                  $('.cart_dropdown .cart_actions .subtotal .money').text('$' + new_subtotal);
                  $('.shopping_bag .cart-count').text(new_quantity);
                  if( new_subtotal <= 0) {                  
                    $('.addmorediscount').hide();                  
                    $('.cart_dropdown .empty_cart').show();
                    $('.cart_dropdown .cart_actions').hide();
                    $('.cart_dropdown .cartfooter').hide();
                    // $('.text-center.chkbtn').eventhide();
                    event.stopPropagation();
                  }
                  renumberCartDropdownLines();
                });
            }
            
          }
             var items = $("div[data-variant-id='" + pvariantId + "']");
			 //$(items).remove();
        }
		 
		if(pvariantId === 'undefined' || pvariantId == ""){
          console.log("Click on Master")
          var items = $("div[data-parent-variant-id='" + variantId + "']");                
          for (var i = 0; i <= items.length; i++) {
            var item = items[i]
            var id = $(item).data('line');            
            if(id != undefined){
              	Shopify.removeQueue.push({lineNum: id});
               $(item).fadeOut(300, function() { 
                //  $(item).remove();
                  $('.cart_dropdown .cart_actions .subtotal .money').text('$' + new_subtotal);
                  $('.shopping_bag .cart-count').text(new_quantity);
                  if( new_subtotal <= 0) {                  
                    $('.addmorediscount').hide();                  
                    $('.cart_dropdown .empty_cart').show();
                    $('.cart_dropdown .cart_actions').hide();
                    $('.cart_dropdown .cartfooter').hide();
                    // $('.text-center.chkbtn').eventhide();

                    event.stopPropagation();
                  }
                  renumberCartDropdownLines();
                });
            }            
          }
             var items = $("div[data-variant-id='" + variantId + "']");
			// $(items).remove();
        }
	Shopify.removeQueue.sort((a,b) => (a.lineNum < b.lineNum) ? 1 : ((b.lineNum < a.lineNum) ? -1 : 0))		
	console.log(Shopify.removeQueue);
	Shopify.moveAlongRemove();
	document.dispatchEvent(new CustomEvent('cartIsEmpty'));            
	});
}
/**************,.icon.icon-x******** Toggle **************************/


$(".overlay-cart,.icon.icon-x").click(function() {
   $(".mobile-nav__has-sublist").removeClass("mobile-nav--expanded");
  //event.stopPropagation();
});

/////////////////////////macbook hack//////////////////////////////////
if(navigator.userAgent.indexOf('Mac') > 0)
jQuery('body').addClass('mac-os');

$(document).ready(function(){
  $(".header-bar__search-submit1").click(function(){
    $(".mobileSearch").show();
    $('input.header-bar__search-input1').focus();
    $("main.main-content").addClass("blurClass");
  });
  $(".closeBtn").click(function(){
  		$(".mobileSearch").hide();
    $("main.main-content").removeClass("blurClass");
  });
  
  
});

/* ISQ Fix cart drawer Discounted Price issue */
function getprice(loadURL,variant_id)
{
  
   loadURL =  loadURL.replace('?variant', '.json?variant');
   jQuery.getJSON(loadURL, function(pd) {
     var product = pd; 
     for (var i = 0; i < (product.product.variants).length; i++) 
     {      
       if(product.product.variants[i].id == variant_id && product.product.variants[i].compare_at_price)
       {         
         var oldprice = "$"+product.product.variants[i].compare_at_price;
         jQuery("#compareme"+variant_id+" span").html(oldprice);
       }
       else if (product.product.variants[i].id == variant_id && !product.product.variants[i].compare_at_price)  {
       jQuery("#compareme"+variant_id+" span").html("");
       }
     }    
   });
}
/** END **/
  
  
 /* $(document).ready(function(){
  $('.thumbnail-slider').bxSlider({
        mode: 'vertical',
        maxSlides: 4,
        slideMargin: 10,
        infiniteLoop: true,
        pager: false,
        prevText: "",
        nextText: "",
        hideControlOnEnd: true
      });
    });*/


//Get K parameter from the URL Start
//Get Cookie function

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

 $(document).ready(function(){   
  //Get K parameter from the URL and add in Cookie
        var url =  new URL(window.location.href);
        var parameters = new URLSearchParams(url.search);          
   
        
   
        if(parameters.has('k')){
          
            if(parameters.get('k')!='' ){
                var discount = parameters.get('k');
              	discount= "k="+discount;
             
                var d = new Date();
                d.setTime(d.getTime() + (1*24*60*60*1000));
                var expires = "expires="+ d.toUTCString();
              
                document.cookie =  "kparam="+discount+";" + expires + ";path=/";

            }else{
                
            }
        }
   
   
   });
   
   
 //Get K parameter from the END